import React, { useState } from 'react';
import './MasterPlanSection.css';

// Import your master plan image (update path according to your assets folder)
import masterPlanImage from '../../assets/ansal-esencia-master-plan.jpg';

const MasterPlanSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (image) => {
    setLightboxImage(image);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
    document.body.style.overflow = 'unset';
  };


  return (
    <section className="master-plan-section" id="master-plan">
      <div className="container">
        <div className="master-plan-layout">
          {/* Left Content */}
          <div className="master-plan-content">
            <div className="master-plan-header">
              <h2 className="master-plan-title">
                Ansal Esencia <span className="highlight">Master Plan</span>
              </h2>
            </div>

            {/* Master Plan Display */}
            <div className="master-plan-display">
              <div className="master-plan-image-container">
                <img 
                  src={masterPlanImage}
                  alt="Ansal Esencia Master Plan"
                  className="master-plan-image"
                  onClick={() => openLightbox(masterPlanImage)}
                />
                <div className="image-overlay">
                  <button 
                    className="zoom-button"
                    onClick={() => openLightbox(masterPlanImage)}
                    aria-label="Click to view full size master plan"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="11" cy="11" r="8"/>
                      <path d="m21 21-4.35-4.35"/>
                      <line x1="11" y1="8" x2="11" y2="14"/>
                      <line x1="8" y1="11" x2="14" y2="11"/>
                    </svg>
                    View Full Size Master Plan
                  </button>
                </div>
              </div>

              <div className="master-plan-info">
                <h3 className="master-plan-info-title">
                  Complete Project Layout - Ansal Esencia Sector 67
                </h3>
                <p className="master-plan-description">
                  Comprehensive master plan showcasing the entire project layout with multiple residential sectors, 
                  wide roads, green spaces, commercial areas, and modern amenities strategically positioned for 
                  optimal living experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-container">
            <button className="lightbox-close" onClick={closeLightbox}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <img 
              src={lightboxImage} 
              alt="Ansal Esencia Master Plan Full Size" 
              className="lightbox-image"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default MasterPlanSection;